module.exports = __webpack_public_path__ + "img/img_sub_ser_solutions.82c2ed93.svg";